import { useListPlaceholderContext } from './ListPlaceholderContextProvider';
import { useEffect, useLayoutEffect } from 'react';

const useElementListPlaceholdersInitialisation = (elementIds: string[], defaultFirstBatchSize?: number) => {
    const { getListInitialRenderSize, saveCurrentListPlaceholderState, generateInitialElementsVisibility } =
        useListPlaceholderContext() || {};

    useEffect(() => {
        generateInitialElementsVisibility(elementIds);
    }, []);

    useLayoutEffect(() => {
        return () => saveCurrentListPlaceholderState();
    }, []);

    return getListInitialRenderSize?.(elementIds, defaultFirstBatchSize) || defaultFirstBatchSize;
};

export default useElementListPlaceholdersInitialisation;
